import { VueExtension } from '../../utils/extensions/vue';
import TabBar from './tabbar.jsx';
import './tabbar.scss';

VueExtension.WithInstall(TabBar);

export default TabBar;
